var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "url(#pattern0_4745_5987)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_4745_5987",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4745_5987",
    transform: "scale(0.04)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4745_5987",
    width: 25,
    height: 25,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAIGNIUk0AAHolAACAgwAA+f8AAIDpAAB1MAAA6mAAADqYAAAXb5JfxUYAAAJiSURBVHja3JYxTBNRGMd/NU43d7Vsba+JQwsdTHqXuOAIhamWEkjq6WacLGdYJICbcSFWHBQsDkohTkKMw11H25qYcEdjIuJY5hsYeA4tpHe9QqtRE7/ky12+9733v/f///PeBYQQ/Om4xF+I/kBGhjcJBL755h2tcNH0wLl0WV8kpmdfMnd/mdCVqm+PWZmk/jnO2qv5wUBKaynMSgpJcoiEnzAxTmn3A6ZZcbVlsxmUYBDe70yy3wi3ipkNlOuHrkYhRHdqeV3IUSEWHwohjoUQx0LT8kIGobUzCKJYXGmNH3wVQssLEQwKUVwZ9a532ZciSXKYugm6m24VeNp+d3E3FILiCjgOOI50sfC5mXXk6GMvQF+x/gIsO+Y1gxskOfIGvbBIeuzX/aoXFomEG0xPLZyW3HR9qo4wFKr6iWyaFVSvP0qvqdXq3WaQpE0s+60/SDsMw8R89hylo6a08zTSwKFhIgzzrFYGEom4q68niFdkv3jgU6v+y2Ol507KPl82AcydmhCwve4fBCSbzZBIxLtE/t5hBguIZjMoSsrVpygp6NCpG0TLr2JW9tQbo1uq6pavVquDx3GqqqBpee9ZBkdHOdJjJ/6aFFeXqNaG2dlNc/hjcPItG8rb9wgETtDnN3oLv16ax7JjLD0aHCQ3A3J0rxPgfHeVt2F6tssMyXZa3h0kr7WefR/1xscQlh3DcST2G2H0wrJxcIDlWURVFeRmE7bf3SUSbrSKioF81en/0gK4fUtHju4hSVu+481mzqvBYDfjGdfZBSw75js2Mb55HkD/IP/P38pvxs8BABZbGOKzaQJwAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedPlus);
export default __webpack_public_path__ + "static/media/redPlus.19d5167a993f31bafdcf4c32ffcb18fd.svg";
export { ForwardRef as ReactComponent };